import { TFunction } from 'i18next';

export const getInputFieldsConfig = (
    firstName: string,
    lastName: string,
    setFirstName: (value: string) => void,
    setLastName: (value: string) => void,
    t: TFunction<'translation', undefined, 'translation'>,
    emailId?: string,
    setEmailId?: (value: string) => void
) => {
    const requiredFields = [
        {
            id: 'firstName',
            label: t('first-name-form-label'),
            value: firstName,
            onChange: setFirstName,
            placeholder: 'John',
        },
        {
            id: 'lastName',
            label: t('last-name-form-label'),
            value: lastName,
            onChange: setLastName,
            placeholder: 'Doe',
        },
    ];

    if (!!setEmailId) {
        return [...requiredFields, {

            id: 'emailId',
            label: t('email-id-form-label'),
            value: emailId,
            onChange: setEmailId,
            placeholder: 'jdoe@example.com',
        }]
    }

    return requiredFields;
}

